import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Navbar } from "./navbar";
import { Contact } from "./contact";
import { ShoppingCart, Heart } from "lucide-react";
import { toggleFavoris } from "./slice";
import "../styles/listeClimatisseurs.css";

const colorMap = {
    'blanc': '#ffffff', 'noir': '#000000', 'noire': '#000000',
    'noir mat': '#222222', 'gris': '#808080', 'gris anthracite': '#2f3e46',
    'argent': '#C0C0C0', 'argenté': '#C0C0C0', 'inox': '#8e9aaf',
    'bleu': '#0000FF', 'rouge': '#FF0000', 'vert': '#008000',
    'or': '#FFD700', 'doré': '#FFD700', 'beige': '#F5F5DC',
    'black': '#000000', 'white': '#ffffff', 'grey': '#808080',
    'gray': '#808080', 'silver': '#C0C0C0', 'blue': '#0000FF',
    'red': '#FF0000', 'green': '#008000', 'gold': '#FFD700'
};

const ClimatiseurCardItem = ({ a }) => {
    const [displayImage, setDisplayImage] = useState(a.image);
    const [activeColor, setActiveColor] = useState(null);

    const handleColorHover = (c) => {
        let newImage = null;
        let newColor = null;

        if (typeof c === 'object' && c !== null) {
            newColor = c.color || c.hex;
            if (c.image && c.image.trim() !== '') {
                newImage = c.image;
            } else if (c.image_url && c.image_url.trim() !== '') {
                newImage = c.image_url;
            }
        } else if (typeof c === 'string') {
            newColor = c;
        }

        if (newImage) {
            setDisplayImage(newImage);
        } else {
            // Revert to main product image if no specific color image exists
            setDisplayImage(a.image);
        }
        
        setActiveColor(newColor);
    };

    return (
        <div className="climatiseur-card" onMouseLeave={() => { setDisplayImage(a.image); setActiveColor(null); }}>
            <div className="card-image-wrapper">
                <img src={displayImage} alt={a.nomClimatisseur} style={{ transition: 'opacity 0.3s ease' }} />
                
                {a.colors && a.colors.length > 0 && (
                    <div className="card-color-dots card-color-dots-floating">
                        {a.colors.map((c, idx) => {
                            const colorName = typeof c === 'string' ? c : (c.color || `Color ${idx}`);
                            const normalized = colorName.trim().toLowerCase();
                            const bgColor = colorMap[normalized] || (typeof c === 'object' ? c.hex : null) || normalized || "#fff";
                            
                            return (
                                <div 
                                    key={idx}
                                    className={`card-color-dot ${activeColor === (c.color || c.hex || c) ? 'active' : ''}`}
                                    style={{ backgroundColor: bgColor }}
                                    onMouseEnter={() => handleColorHover(c)}
                                    title={colorName}
                                ></div>
                            );
                        })}
                    </div>
                )}
            </div>
            <div className="card-info">
                <h3 className="climatiseur-name">{a.nomClimatisseur}</h3>
                <p className="climatiseur-price">{a.tailles && a.tailles.length > 0 ? a.tailles[0].prix : 0} DH</p>

                <div className="card-actions-wrapper">
                    <Link to={`/listeClimatisseurs/${a.id}`} state={{ fromList: true }} className="btn-add-cart">
                        <ShoppingCart className="icon-cart" size={18} /> Ajouter au panier
                    </Link>
                </div>
            </div>
        </div>
    );
};

export function ListeClimatisseurs({ isHome }) {
    const listC = useSelector(s => s.listC);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const cherche = useSelector(s => s.cherche);
    const favoris = useSelector(s => s.favoris) || [];
    const list = listC.filter(a => a.nomClimatisseur.toLowerCase().includes(cherche.toLowerCase()));

    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    let limit = list.length;
    if (isHome) {
        if (width >= 5120) limit = 14;
        else if (width >= 3400) limit = 12;
        else if (width >= 2000) limit = 12;
        else if (width >= 1536) limit = 10;
        else if (width >= 1110) limit = 8;
        else if (width >= 1000) limit = 6;
        else if (width >= 600) limit = 4;
        else limit = 4;
    }

    const displayedList = list.slice(0, limit);


    return (
        <>
            {!isHome && <Navbar />}

            <div className={`climatiseurs-list-container ${!isHome ? 'full-page-list' : ''}`}>
                <div className="section-title-bar" style={!isHome ? { backgroundColor: '#000033' } : {}}>
                    Les climatiseurs
                </div>

                <div className="climatiseurs-grid">
                    {displayedList.map(a => (
                        <ClimatiseurCardItem key={a.id} a={a} />
                    ))}
                </div>

                {list.length === 0 && cherche && (
                    <div style={{ textAlign: 'center', marginBottom: '60px', marginTop: '-50px' }}>
                        <p>Aucun climatisseur trouvé pour "{cherche}"</p>
                    </div>
                )}

                {isHome && (
                    <div className="view-all-container">
                        <button className="btn-view-all" onClick={() => navigate('/listeClimatisseurs')}>
                            Voir tous les climatiseurs
                        </button>
                    </div>
                )}
            </div>
            {!isHome && <Contact />}
        </>
    );
};
